<template>
  <div class="reg-panel">
    <div class="panel-body">
      <div class="row g-3 align-items-start">

        <!-- Columna izquierda: búsqueda y tabla de seleccionados -->
        <div class="col-8">
          <div class="search-tabs">
            <button
              v-for="tab in tabs" :key="tab.key"
              class="search-tab"
              :class="{ active: tabActivo === tab.key }"
              @click="cambiarTab(tab.key)"
              type="button"
            >
              <span class="material-symbols-outlined" style="font-size:16px">{{ tab.icon }}</span>
              {{ tab.label }}
            </button>
          </div>

          <div class="search-box mt-2">
            <div class="d-flex gap-1">
              <button type="button" class="btn-reload" @click="cargarElementos" title="Cargar elementos">
                <span class="material-symbols-outlined" style="font-size:18px">search</span>
              </button>
              <div style="position:relative; flex:1;">
                <input
                  type="text"
                  class="search-input"
                  v-model="filtro"
                  :placeholder="tabActual.placeholder"
                  :disabled="items.length === 0"
                  @input="filtrarItems"
                  @focus="mostrarDropdown = true"
                  @blur="ocultarConDelay"
                  autocomplete="off"
                />
                <div v-if="mostrarDropdown && itemsFiltrados.length > 0" class="search-dropdown">
                  <div
                    v-for="item in itemsFiltrados" :key="item.idElemento"
                    @mousedown="agregarElemento(item)"
                    class="dropdown-item-custom"
                    :class="{ selected: yaSeleccionado(item.idElemento) }"
                  >
                    <span class="item-code">{{ item.elementoCodigo }}</span>
                    <span class="item-sep">—</span>
                    <span class="item-name">{{ item.elementoNombre }}</span>
                    <span v-if="yaSeleccionado(item.idElemento)" class="item-check">
                      <span class="material-symbols-outlined" style="font-size:14px;color:#198754">check</span>
                    </span>
                  </div>
                </div>
                <div
                  v-if="mostrarDropdown && filtro && itemsFiltrados.length === 0 && items.length > 0"
                  class="search-dropdown no-results"
                >
                  Sin resultados para "{{ filtro }}"
                </div>
              </div>
            </div>

            <div class="search-status mt-1">
              <span v-if="buscando" class="text-muted">
                <span class="material-symbols-outlined spin" style="font-size:14px">progress_activity</span>
                Cargando...
              </span>
              <span v-else-if="items.length === 0" class="text-muted">
                Sin elementos — presione 🔍 para cargar
              </span>
              <span v-else class="text-muted">
                {{ items.length }} elementos disponibles
              </span>
            </div>
          </div>

          <div v-if="seleccionados.length" class="tabla-seleccionados mt-3">
            <div class="tabla-header">
              <span>Código</span>
              <span>Nombre</span>
              <span>Cant.</span>
              <span></span>
            </div>
            <div
              v-for="(item, idx) in seleccionados" :key="item.idElemento"
              class="tabla-row"
              :class="{ 'tabla-row-alt': idx % 2 === 1 }"
            >
              <span class="item-code">{{ item.elementoCodigo }}</span>
              <span class="item-name-sm">{{ item.elementoNombre }}</span>
              <input
                type="number"
                class="cantidad-input"
                v-model.number="item.cantidad"
                min="1"
                step="1"
                @change="item.cantidad = Math.max(1, item.cantidad || 1)"
              />
              <button type="button" class="btn-remove" @click="quitarElemento(idx)" title="Quitar">
                <span class="material-symbols-outlined" style="font-size:16px">close</span>
              </button>
            </div>
          </div>

          <div v-else class="tabla-vacia mt-3">
            <span class="material-symbols-outlined" style="font-size:28px; color:#ced4da">add_circle</span>
            <p class="mt-1 mb-0">Seleccione elementos desde el buscador</p>
          </div>
        </div>

        <!-- Columna derecha: fecha y acciones -->
        <div class="col-4 d-flex flex-column gap-3" style="padding-top:2rem;">
          <div>
            <label class="field-label">
              <span class="material-symbols-outlined" style="font-size:15px; vertical-align:middle">event</span>
              Fecha de atención
            </label>
            <input
              type="date"
              class="form-control form-control-sm"
              v-model="fechaAtencion"
              :min="fechaDesde"
              :max="fechaHasta"
            />
          </div>

          <div v-if="seleccionados.length" class="resumen-box">
            <div class="resumen-row">
              <span>Elementos</span>
              <strong>{{ seleccionados.length }}</strong>
            </div>
            <div class="resumen-row">
              <span>Total ítems</span>
              <strong>{{ totalItems }}</strong>
            </div>
          </div>

          <button
            type="button" class="btn-action success"
            @click="guardar"
            :disabled="!puedeGuardar"
            title="Registrar elementos en la planilla"
          >
            <span class="material-symbols-outlined">save</span>
            Registrar
          </button>
          <button
            type="button" class="btn-action secondary"
            @click="limpiar"
            title="Limpiar selección"
          >
            <span class="material-symbols-outlined">delete</span>
            Limpiar
          </button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import api from "@/services/api";
import Swal from "sweetalert2";

export default {
  name: "RegistroVariosCodigos",

  props: {
    idPlanilla:  { type: [Number, String], required: true },
    idPrestador: { type: [Number, String], required: true },
    idUsuario:   { type: [Number, String], required: true },
    fechaDesde:  { type: String, required: true },
    fechaHasta:  { type: String, required: true },
  },

  emits: ["guardado"],

  data() {
    return {
      tabActivo: "prestaciones",
      tabs: [
        { key: "prestaciones", label: "Prestaciones", icon: "medical_services", placeholder: "Buscar por código o nombre..." },
        { key: "medicamentos", label: "Medicamentos", icon: "medication",        placeholder: "Buscar medicamento..."         },
        { key: "insumos",      label: "Insumos",      icon: "inventory_2",       placeholder: "Buscar insumo..."              },
      ],
      items:           [],
      itemsFiltrados:  [],
      filtro:          "",
      buscando:        false,
      mostrarDropdown: false,
      seleccionados:   [],
      fechaAtencion:   "",
    };
  },

  computed: {
    tabActual() {
      return this.tabs.find(t => t.key === this.tabActivo) || this.tabs[0];
    },
    totalItems() {
      return this.seleccionados.reduce((acc, i) => acc + (i.cantidad || 1), 0);
    },
    puedeGuardar() {
      return this.seleccionados.length > 0 && !!this.fechaAtencion;
    },
  },

  watch: {
    fechaDesde(val) { if (val && !this.fechaAtencion) this.fechaAtencion = val; },
  },

  mounted() {
    if (this.fechaDesde) this.fechaAtencion = this.fechaDesde;
  },

  methods: {
    cambiarTab(tab) {
      this.tabActivo      = tab;
      this.items          = [];
      this.itemsFiltrados = [];
      this.filtro         = "";
    },

    endpointPorTab() {
      const map = {
        prestaciones: `/vwtarifapress/idprestador/${this.idPrestador}`,
        medicamentos:  `/vwtarifapress/idprestador/10`,
        insumos:       `/vwtarifapress/idprestador/11`,
      };
      return map[this.tabActivo];
    },

    async cargarElementos() {
      this.buscando       = true;
      this.items          = [];
      this.itemsFiltrados = [];
      this.filtro         = "";
      try {
        const response  = await api.get(this.endpointPorTab());
        this.items = response.data;
      } catch {
        Swal.fire("Error", "No se pudo cargar los elementos", "error");
      } finally {
        this.buscando = false;
      }
    },

    filtrarItems() {
      this.mostrarDropdown = true;
      if (!this.filtro.trim()) { this.itemsFiltrados = []; return; }
      const f = this.filtro.toLowerCase();
      this.itemsFiltrados = this.items.filter(i =>
        (i.elementoCodigo ?? "").toLowerCase().includes(f) ||
        (i.elementoNombre ?? "").toLowerCase().includes(f)
      ).slice(0, 50);
    },

    ocultarConDelay() {
      setTimeout(() => { this.mostrarDropdown = false; }, 200);
    },

    yaSeleccionado(idElemento) {
      return this.seleccionados.some(s => s.idElemento === idElemento);
    },

    agregarElemento(item) {
      if (this.yaSeleccionado(item.idElemento)) return;
      this.seleccionados.push({ ...item, cantidad: 1 });
      this.filtro          = "";
      this.itemsFiltrados  = [];
      this.mostrarDropdown = false;
    },

    quitarElemento(idx) {
      this.seleccionados.splice(idx, 1);
    },

    limpiar() {
      this.seleccionados   = [];
      this.filtro          = "";
      this.itemsFiltrados  = [];
      this.items           = [];
      this.mostrarDropdown = false;
    },

    async guardar() {
      if (!this.puedeGuardar) {
        Swal.fire("Atención", "Seleccione al menos un elemento y una fecha de atención", "warning");
        return;
      }
      const confirm = await Swal.fire({
        title:  "¿Confirmar registro?",
        html:   `Se registrarán <strong>${this.seleccionados.length}</strong> elemento(s) con fecha <strong>${this.fechaAtencion}</strong>`,
        icon:   "question",
        showCancelButton:   true,
        confirmButtonText:  "Sí, registrar",
        cancelButtonText:   "Cancelar",
        confirmButtonColor: "#198754",
      });
      if (!confirm.isConfirmed) return;

      const errores = [];
      let guardados = 0;

      for (const item of this.seleccionados) {
        const payload = {
          idPlanilla:    Number(this.idPlanilla),
          idElemento:    item.idElemento,
          idUsuarioReg:  Number(this.idUsuario),
          descripcion:   "automático",
          cantidad:      item.cantidad || 1,
          cantidadIni:   item.cantidad || 1,
          fechaAtencion: this.fechaAtencion,
          fechaReg:      new Date().toISOString(),
          estado:        1,
        };
        try {
          await api.post("/planilladets", payload);
          guardados++;
        } catch (e) {
          errores.push(`${item.elementoCodigo}: ${e.response?.data || e.message}`);
        }
      }

      if (errores.length === 0) {
        Swal.fire("Éxito", `${guardados} elemento(s) registrado(s) correctamente`, "success");
        this.limpiar();
        this.$emit("guardado");
      } else {
        Swal.fire({
          title: `${guardados} guardado(s), ${errores.length} con error`,
          html:  `<ul style="text-align:left;font-size:13px">${errores.map(e => `<li>${e}</li>`).join("")}</ul>`,
          icon:  "warning",
        });
        this.$emit("guardado");
      }
    },
  },
};
</script>

<style scoped>
.reg-panel {
  background: #f8f9fa;
}
.panel-body {
  padding: 14px 16px;
}
/* Tabs */
.search-tabs { display: flex; gap: 4px; border-bottom: 2px solid #dee2e6; }
.search-tab {
  display: inline-flex; align-items: center; gap: 5px;
  padding: 6px 12px; border: none; background: transparent;
  font-size: 0.8rem; color: #6c757d; cursor: pointer;
  border-bottom: 2px solid transparent; margin-bottom: -2px;
  border-radius: 4px 4px 0 0; transition: all 0.15s;
}
.search-tab:hover  { background: #f0f4ff; color: #0d6efd; }
.search-tab.active { color: #0d6efd; border-bottom-color: #0d6efd; font-weight: 600; background: #fff; }
/* Search */
.search-input {
  width: 100%; padding: 6px 10px; border: 1px solid #ced4da;
  border-radius: 4px; font-size: 0.85rem; transition: border-color 0.15s;
}
.search-input:focus    { outline: none; border-color: #0d6efd; box-shadow: 0 0 0 2px rgba(13,110,253,.15); }
.search-input:disabled { background: #f8f9fa; }
.btn-reload {
  display: flex; align-items: center; justify-content: center;
  padding: 6px 10px; border: 1px solid #ced4da; border-radius: 4px;
  background: #fff; cursor: pointer; color: #495057; transition: all 0.15s;
}
.btn-reload:hover { background: #0d6efd; color: #fff; border-color: #0d6efd; }
.search-dropdown {
  position: absolute; z-index: 1000; width: 100%;
  max-height: 260px; overflow-y: auto;
  background: #fff; border: 1px solid #ced4da;
  border-top: none; border-radius: 0 0 6px 6px;
  box-shadow: 0 6px 16px rgba(0,0,0,.12);
}
.dropdown-item-custom {
  display: flex; align-items: center; gap: 4px;
  padding: 7px 10px; cursor: pointer;
  border-bottom: 1px solid #f0f0f0; font-size: 0.82rem; transition: background 0.1s;
}
.dropdown-item-custom:hover,
.dropdown-item-custom.selected { background: #e7f1ff; }
.item-code    { font-weight: 700; color: #0d6efd; white-space: nowrap; }
.item-sep     { color: #adb5bd; margin: 0 2px; }
.item-name    { color: #343a40; flex: 1; }
.item-check   { margin-left: auto; }
.item-name-sm {
  color: #343a40; font-size: 0.8rem; flex: 1;
  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
}
.no-results   { padding: 10px; font-size: 0.85rem; color: #6c757d; }
.search-status { font-size: 0.78rem; }
/* Tabla seleccionados */
.tabla-seleccionados {
  border: 1px solid #dee2e6; border-radius: 6px; overflow: hidden; font-size: 0.82rem;
}
.tabla-header {
  display: grid; grid-template-columns: 90px 1fr 60px 32px;
  background: #e9ecef; padding: 5px 8px; font-weight: 700; color: #495057; gap: 6px;
}
.tabla-row {
  display: grid; grid-template-columns: 90px 1fr 60px 32px;
  padding: 5px 8px; align-items: center; gap: 6px;
  border-top: 1px solid #f0f0f0; background: #fff;
}
.tabla-row-alt { background: #f8f9fa; }
.cantidad-input {
  width: 54px; padding: 3px 5px; border: 1px solid #ced4da;
  border-radius: 4px; font-size: 0.8rem; text-align: center;
}
.cantidad-input:focus { outline: none; border-color: #0d6efd; }
.btn-remove {
  display: flex; align-items: center; justify-content: center;
  width: 26px; height: 26px; border: 1px solid #f5c6cb;
  border-radius: 4px; background: #fff8f8; cursor: pointer;
  color: #dc3545; transition: all 0.12s;
}
.btn-remove:hover { background: #dc3545; color: #fff; border-color: #dc3545; }
.tabla-vacia {
  display: flex; flex-direction: column; align-items: center;
  padding: 20px; color: #adb5bd; font-size: 0.85rem;
  border: 2px dashed #dee2e6; border-radius: 6px; background: #fff;
}
/* Resumen */
.resumen-box {
  background: #fff; border: 1px solid #dee2e6;
  border-radius: 6px; padding: 10px 12px; font-size: 0.82rem;
}
.resumen-row {
  display: flex; justify-content: space-between; padding: 2px 0; color: #495057;
}
/* Field label */
.field-label { font-weight: 600; font-size: 0.85rem; color: #495057; display: block; margin-bottom: 4px; }
/* Action buttons */
.btn-action {
  display: flex; align-items: center; justify-content: center; gap: 6px;
  padding: 8px 14px; border: none; border-radius: 6px;
  font-size: 0.85rem; font-weight: 600; cursor: pointer;
  transition: all 0.15s; width: 100%;
}
.btn-action.success              { background: #198754; color: #fff; }
.btn-action.success:hover:not(:disabled) { background: #157347; }
.btn-action.secondary            { background: #fff; color: #6c757d; border: 1px solid #dee2e6; }
.btn-action.secondary:hover      { background: #f8f9fa; }
.btn-action:disabled             { opacity: 0.45; cursor: not-allowed; }
@keyframes spin { to { transform: rotate(360deg); } }
.spin { display: inline-block; animation: spin 1s linear infinite; }
</style>